<template>
    <a v-if="coi" @click.prevent.stop='openInsuraceCertificates()' href="#">Yes</a>
    <a v-else @click.prevent.stop='openInsuraceCertificates()' href="#">No</a>

</template>

<script>

export default {
    name: "ScheduleCoiRequired",
        props: ['coi'],
    data() {
        return {

        }

    },
    mounted() {


    },
    methods: {
        openInsuraceCertificates (){
            this.$root.$refs.modalInsuranceCertificate.show();
        }
    }
}
</script>

<style scoped>


</style>
